"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var rocket_1 = require("../../core/rocket");
var adaptive_1 = __importDefault(require("./adaptive"));
var Small = function (_a) {
    var fill = _a.fill, title = _a.title, background = _a.background, rest = __rest(_a, ["fill", "title", "background"]);
    return (react_1.default.createElement("svg", __assign({ viewBox: "0 0 91 91", fill: "none", version: "1.1" }, rest),
        title && react_1.default.createElement("title", null, title),
        react_1.default.createElement("circle", { cx: "45.5", cy: "45.5", r: "45.5", fill: fill }),
        react_1.default.createElement("g", { transform: "translate(19.266963,19.266963)" },
            react_1.default.createElement(rocket_1.Rocket, { width: 51, height: 51 }))));
};
var Adboost = function (props) {
    var _a = props.fill, fill = _a === void 0 ? '#0387B1' : _a, name = props.name, rest = __rest(props, ["fill", "name"]);
    return react_1.default.createElement(adaptive_1.default, __assign({ small: Small, fill: fill, shift: -10 }, rest));
};
exports.default = Adboost;
